import { streamRequest, StreamOptions } from '../http/sseClient'

export interface UploadFilesRequest {
  url: string
  code: string
  name: string
  files: File[]
}
export async function uploadFiles(
  { url, code, name, files }: UploadFilesRequest,
  options?: StreamOptions,
) {
  const formData = new FormData()
  formData.append('url', url)
  formData.append('name', name)
  formData.append('code', code)

  files.forEach((file, index) => {
    formData.append(`arquivo_${index}`, file)
  })

  return streamRequest<any>({
    method: 'PUT',
    path: '/crefisa/files',
    body: formData,
    ...options,
  })
}
